<!--
  template(if) - list(show) 구조는 불필요한 로드를 방지하기 위해서임.
  refresh 는 add, edit 성공시 호출해야 함.
-->

<template>
  <div class="animated fadeIn">
    <div class="page-header d-flex">
      <h4 class="page-title">
        <i class="fas fa-th-list"></i>
        WSFinder & WMDS Main
      </h4>
      <ul class="breadcrumbs ml-auto">
        <li class="nav-home mr-1">
          <a href="#">
            <i class="fas fa-home text-muted"></i>
          </a>
        </li>
        <li class="nav-item">
          <a class="font_15" href="#">WFDetector</a>
        </li>
        <li class="separator">
          <i class="flaticon-right-arrow"></i>
        </li>
        <li class="nav-item">
          <a class="font_15 font-weight-bold" href="#">Main</a>
        </li>
      </ul>
    </div>
    <template v-if="base">
      <div class="d-flex flex-wrap align-items-center">
        <b-col sm="2">
        </b-col>
        <b-col class="md-10 d-flex flex-wrap align-items-center">
          <b-input-group>
            <div class="mr-auto mb7"></div>
            <div class="mb7 form-inline">
              <span class="float-right">
                <button @click="pause" size="sm" class="btn btn-sm btn-primary">
                  <span :class="`fa fa-refresh ${sync.th && !sync.stop ? 'fa-spin' : ''}`"></span>
                  Pause
                </button>
              </span>
            </div>
          </b-input-group>
          <br>
          <b-input-group size="sm">
            <div class="mr-auto mb7"></div>
            <div class="mb7 form-inline">
              <label class="col-form-label mr-2" v-b-tooltip.hover title="can see the log real-time">
                Real-time refresh interval
              </label>
              <select class="form-control mr-2" v-model="sync.interval" @change="refresh">
                <option disabled value="15">Please select interval : Default 15</option>
                <option value=10>10</option>
                <option value=30>30</option>
                <option value=60>60</option>
                <option value=300>300(5 min)</option>
              </select>
              <label class="col-form-label mr-2" for="sel3">sec</label>
            </div>
          </b-input-group>
        </b-col>
      </div>
      <b-row>
        <b-col class="flex-wrap align-items-center mb10">
          <ListWSFinderResult v-show="list_wsfinder_result" ref="list_wsfinder_result" :is_main="true" :limit="20"/>
        </b-col>
        <b-col class="flex-wrap align-items-center mb10">
          <ListWMDSResult v-show="lsit_wmds_result" ref="list_wmds_result" :is_main="true" :limit="20"/>
        </b-col>
      </b-row>
    </template>
  </div>
</template>

<script>
  import App from './app.js'; export default Object.assign({}, App);
</script>